import Lenis from 'lenis'
import { animate, inView, stagger, delay, scroll, cubicBezier } from "motion"

// Smooth Scroll
const lenis = new Lenis({
  anchors:{
     offset: -150
  },
  prevent: (node) => node.id === 'mobileMenu',
});
function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

// make it use for alpine
window.lenis = lenis;


// Utils
const easing = cubicBezier(.35,.17,.3,.86)

const splitText = (textContainer, classTxt = "animate_title__span") => {
  if (!textContainer) {
    console.error("Element not found")
    return
  }
  const originalText = textContainer.innerHTML.trim();
  textContainer.textContent = ""
  originalText.split(" ").forEach((char) => {
    const charElement = document.createElement("span")
    charElement.classList.add(classTxt)
    charElement.innerHTML = char
    textContainer.appendChild(charElement)
  })
}

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('.split-text');
  const elementsNodes = document.querySelectorAll('.split-text-node');

  elementsNodes.forEach(element => {
    splitText(element, "animate_title_node__span");
  });
  elements.forEach(element => {
    splitText(element);
    // Get all animated characters
    const chars = element.querySelectorAll('.animate_title__span');

    // Set initial state
    chars.forEach(char => {
      char.style.opacity = 0;
    });

    // Animate when in view
    inView(element, () => {
      animate(
        chars,
        {
          opacity: 1,
        },
        {
          easing:easing,
          delay: stagger(0.05)
        }
      );
      return () => {};
    });
  });

});


// Image scale with opactiy animation
document.querySelectorAll(".anime-scale-img  img").forEach((item) => {
  scroll(animate(item, {scale: [1, 1.1, 1.1, 1.1] }, { ease: easing }), {
      target: item,
      offset: ["start end", "center center", "center center", "end start"], 
      // offset: ["start start", "end end", "start 0.8", "end 0.9"],
  });
  scroll(animate(item, {
    opacity: [1, 0] },{ easing: "ease-in-out" }), {
    target: item,
    offset: ["start start", "end start"],
})
})


// Cta Icon grid block animation
inView(".cta-icon-grid", ({target})=>{
  animate(".cta-icon-grid .anim-block",
      { opacity: [0,1], y: [10, 0] },
      {
          delay: stagger(0.1),
          easing:"circInOut",
   });

  return () => null;
},{
   root:document.querySelector('.cta-icon-grid'),
   margin: "0px 0px 0px 0px",
});

inView(".anim-content", ({target})=>{
  animate(".anim-content div",
      { opacity: [0,1], y: [10, 0] },
      {
          delay: stagger(0.1),
          easing:"circInOut",
  });
  return () => {};
});

// Animations for desktop sizes
if (window.innerWidth >= 1024) { 
  inView(".anim-slide-up", ({target})=>{
     animate(target,
         { opacity: [0,1], y: [100, 0] },
         {  duration: 0.5,easing: [0.17, 0.55, 0.55, 1],});
     return () => null;
   },{
   });
}

inView(".anim-slide-up-stagger-divs div", ({target})=>{
  animate(target,
      { opacity: [0,1], y: [100, 0] },
      {
        delay: stagger(0.3),
        easing:"ease-in-out",
  });

  return () => {};
});

inView(".anim-slide-up-stagger ", ({target})=>{
  animate(".anim-slide-up-stagger--item",
      { opacity: [0,1], x: [-10, 0] },
      {
        delay: stagger(0.05),
        easing: "ease-in-out" ,
  });

  return () => {};
});


